import localforage from "localforage";

localforage.config({
	name: "localforage",
	storeName: "bo-persist",
	driver: localforage.LOCALSTORAGE,
});

export default localforage;
